import getAxios from '@/utils/axios-request'

export async function getDeveloperInfo(developerId) {
  const axios = await getAxios()
  return axios({
    url: `/api/v1/tsps/${developerId}`,
    method: 'get'
  })
//   .catch(() => {
//     return {
//       data: [
//         {
//           id: 'e31b7039-1f98-4617-9372-3d1284312be8',
//           tsp_name: 'mReferral Corporation(HK) Limited',
//           tsp_name_chinese: '經絡按揭轉介',
//           tsp_logo: '',
//           tsp_banner: '',
//           tsp_description: '經絡集團(香港)有限公司(經絡按揭轉介)成立於2000年，是長江和記實業有限公司及美聯集團有限公司組成之聯營公司，專注按揭轉介業務，規模龐大。經絡按揭轉介擁有全港專注樓宇按揭銀行的按揭計劃，提供逾50間金融機構共100多款按揭及轉按套現產品，致力為客戶提供優質的按揭轉介服務及最新按揭資訊。 mReferral Corporation (HK) Limited (mReferral Mortgage Brokerage Services) is a joint venture of CK Hutchison Holdings Limited and Midland Holdings Limited. mReferral offers the mortgage plans from all banks with mortgage services in Hong Kong. We partner with over 50 banks and financial institutions, providing more than 100 mortgage and refinance products.',
//           tsp_website: 'https://www.mreferral.com',
//           tsp_email: 'info@mreferral.com',
//           tsp_tel: '852-3196-6600',
//           tsp_fax: '852-3196-6678'
//         }
//       ]
//     }
//   })
}

export async function getDeveloperInfoInStaging(developerId) {
  const axios = await getAxios()
  return axios({
    url: `/api/v1/tsps_staging/${developerId}`,
    method: 'get'
  })
//   .catch(() => {
//     return {
//       data: [
//         {
//           id: 'e31b7039-1f98-4617-9372-3d1284312be8',
//           tsp_name: 'mReferral Corporation(HK) Limited',
//           tsp_name_chinese: '經絡按揭轉介',
//           tsp_logo: '',
//           tsp_banner: '',
//           tsp_description: '經絡集團(香港)有限公司(經絡按揭轉介)成立於2000年，是長江和記實業有限公司及美聯集團有限公司組成之聯營公司，專注按揭轉介業務，規模龐大。經絡按揭轉介擁有全港專注樓宇按揭銀行的按揭計劃，提供逾50間金融機構共100多款按揭及轉按套現產品，致力為客戶提供優質的按揭轉介服務及最新按揭資訊。 mReferral Corporation (HK) Limited (mReferral Mortgage Brokerage Services) is a joint venture of CK Hutchison Holdings Limited and Midland Holdings Limited. mReferral offers the mortgage plans from all banks with mortgage services in Hong Kong. We partner with over 50 banks and financial institutions, providing more than 100 mortgage and refinance products.',
//           tsp_website: 'https://www.mreferral.com',
//           tsp_email: 'info@mreferral.com',
//           tsp_tel: '852-3196-6600',
//           tsp_fax: '852-3196-6678'
//         }
//       ]
//     }
//   })
}

export async function searchDeveloper(industry) {
  const axios = await getAxios()
  return axios({
    url: `/api/v1/tsps?industry=${industry}`,
    method: 'get',
    headers: {
      'Prefer': 'count=exact'
    }
  })
//   .catch(() => {
//     //  TODO: Remove stub data or change the format of it for fallback data.
//     console.log('Fallback to use stub data for searchProvider')
//     return {
//       headers: {
//         'content-range': '0-3/4'
//       },
//       data: [
//         {
//           id: '0cafecbc-0cd9-49d2-80be-8cd560f12e4c',
//           tsp_name: 'A.S. WATSON MONEYBACK (HK) LIMITED 屈臣氏易賞錢(香港)有限公司',
//           tsp_logo: ''
//         },
//         {
//           id: '46bfaa0c-0ee9-43cf-906e-084476bbad9e',
//           tsp_name: 'A.S. WATSON RETAIL (HK) LIMITED 屈臣氏零食(香港)有限公司',
//           tsp_logo: ''
//         },
//         {
//           id: '85aaff3d-0c28-4c3b-a9ef-f105eaa735db',
//           tsp_name: 'AIA Shared Services (Hong Kong) Limited 友邦綜合服務(香港) 有限公司',
//           tsp_logo: ''
//         },
//         {
//           id: '53898a11-5f11-439f-bb59-6058b00c97ed',
//           tsp_name: 'Alipay Payment Services (HK) Limited',
//           tsp_logo: ''
//         }
//       ]
//     }
//   })
}

export async function getProjectInfoList(developerId, industry) {
  const axios = await getAxios()
  return axios({
    url: `/api/v1/tsps/${developerId}/projects?industry=${industry}`,
    method: 'get'
  })
//   .catch(() => {
//     return {
//       data: [
//         {
//           id: 'cdada193-d134-4d16-9146-2db20560103e',
//           project_name: 'Mortgage application 按揭申請',
//           project_description: '1.Web 2. App: through web view access our website',
//           project_logo: '',
//           product_url: 'https://www.mreferral.com/en/apply-now/',
//           product_url_ios: 'https://apps.apple.com/hk/app/%E7%B6%93%E7%B5%A1%E6%8C%89%E6%8F%AD%E8%BD%89%E4%BB%8B/id404129494?l=en',
//           product_url_android: 'https://play.google.com/store/apps/details?id=com.midland.mreferral&hl=zh_HK',
//           services: [
//             {
//               id: '2f0dd5b8-d0c4-461b-a965-6041bdbed01e',
//               name: 'Retrieve motor insurance product details',
//               api_phase: 'Customer Acquisition',
//               category_id: 'Insurance',
//               brief_description: 'This API is to get motor insurance product details',
//               bank: {
//                 id: 'd217260a-20e8-4d33-8355-befb5d3e78f0',
//                 bank_name: 'Bank of China (Hong Kong)',
//                 bank_code: '012',
//                 bank_logo: ''
//               }
//             },
//             {
//               id: '2fd2546e-7fd7-4f53-8ae8-9f72790ef97c',
//               name: 'Retrieve retail investment fund product details list',
//               api_phase: 'Transactions',
//               category_id: 'Investments',
//               brief_description: 'Retrieve retail investment fund product details list',
//               bank: {
//                 id: 'd217260a-20e8-4d33-8355-befb5d3e78f0',
//                 bank_name: 'Bank of China (Hong Kong)',
//                 bank_code: '012',
//                 bank_logo: ''
//               }
//             },
//             {
//               api_id: '3ad90ee1-f31e-4d7b-a441-83ecf4c7ca17',
//               name: 'Safe Deposit Box',
//               api_phase: 'Product Information',
//               category_id: 'Safe Deposit Box',
//               brief_description: 'This API is to get safe deposit box product details',
//               bank: {
//                 id: 'd217260a-20e8-4d33-8355-befb5d3e78f0',
//                 bank_name: 'Bank of China (Hong Kong)',
//                 bank_code: '012',
//                 bank_logo: ''
//               }
//             },
//             {
//               api_id: '4c71eb39-8ec4-497f-886f-4f278bc68ffe',
//               name: 'Retrieve DBS\'s ATM details',
//               api_phase: 'Customer Acquisition',
//               category_id: 'Other banking services',
//               brief_description: 'This API returns DBS\'s branch details.',
//               bank: {
//                 id: '0434d701-d4f5-4886-9b17-abb948ab5e95',
//                 bank_name: 'DBS Bank (Hong Kong) Limited',
//                 bank_code: '039',
//                 bank_logo: ''
//               }
//             },
//             {
//               api_id: '4cb12907-315a-4c50-8ba0-5c33f9331105',
//               name: 'Retrieve endowment product details list',
//               api_phase: 'Product Information',
//               category_id: 'Insurance',
//               brief_description: 'Retrieve endowment plan product details list',
//               bank: {
//                 id: '0434d701-d4f5-4886-9b17-abb948ab5e95',
//                 bank_name: 'DBS Bank (Hong Kong) Limited',
//                 bank_code: '039',
//                 bank_logo: ''
//               }
//             }
//           ]
//         },
//         {
//           id: 'ce2db106-ef39-46eb-9069-b0e6c6cb4d37',
//           project_name: 'P Loan application 私人貸款申請',
//           project_description: 'Web',
//           project_logo: '',
//           product_url: 'https://www.mreferral.com/%E8%B2%B8%E6%AC%BE%E8%A8%88%E5%8A%83',
//           product_url_ios: '',
//           product_url_android: '',
//           services: [
//             {
//               api_id: '4df2da8f-f31f-43a3-a6ab-c009f3d8f3e6',
//               name: 'Retrieve retail investment fund product details list',
//               api_phase: 'Customer Acquisition',
//               brief_description: 'Retrieve retail investment fund product details list',
//               category_id: 'Investments',
//               bank: {
//                 id: 'ea29fd5e-d84b-4e7c-afa4-a3b4f324bc3e',
//                 bank_name: 'Bank of Communications (Hong Kong) Limited',
//                 bank_code: '382',
//                 bank_logo: ''
//               }
//             }
//           ]
//         }
//       ]
//     }
//   })
}
